export const slavesConstants = {
  SET_STATS_REQUEST: 'SET_SLAVES_STATS_REQUEST',
  SET_STATS_SUCCESS: 'SET_SLAVES_STATS_SUCCESS',
  SET_STATS_FAILURE: 'SET_SLAVES_STATS_FAILURE',

  DELETE_SLAVE_SUCCESS: 'DELETE_SLAVE_SUCCESS',
  DELETE_SLAVE_FAILURE: 'DELETE_SLAVE_FAILURE',

  SET_SLAVE_WALLETS_SUCCESS: 'SET_SLAVE_WALLETS_SUCCESS',
  SET_SLAVE_WALLETS_FAILURE: 'SET_SLAVE_WALLETS_FAILURE',
  ADD_SLAVE_WALLETS_SUCCESS: 'ADD_SLAVE_WALLETS_SUCCESS',

  SET_SLAVE_BALANCE_SUCCESS: 'SET_SLAVE_BALANCE_SUCCESS',
  SET_SLAVE_BALANCE_FAILURE: 'SET_SLAVE_BALANCE_FAILURE',

  SET_SLAVE_PAYMENT_ORDERS_SUCCESS: 'SET_SLAVE_PAYMENT_ORDERS_SUCCESS',
  SET_SLAVE_PAYMENTS_DATA_SUCCESS: 'SET_SLAVE_PAYMENTS_DATA_SUCCESS',
  SET_SLAVE_PAYMENTS_DATA_FAILURE: 'SET_SLAVE_PAYMENTS_DATA_FAILURE',
  SET_SLAVE_HOLD_DETAILS_SUCCESS: 'SET_SLAVE_HOLD_DETAILS_SUCCESS',
  SET_SLAVE_HOLD_DETAILS_SETTINGS_SUCCESS: 'SET_SLAVE_HOLD_DETAILS_SETTINGS_SUCCESS',

  SET_SLAVE_OFFERS_LIST_SUCCESS: 'SET_SLAVE_OFFERS_LIST_SUCCESS',
  SET_SLAVE_OFFERS_LIST_FAILURE: 'SET_SLAVE_OFFERS_LIST_FAILURE',

  SET_SLAVE_STREAMS_SUCCESS: 'SET_SLAVE_STREAMS_SUCCESS',
  SET_SLAVE_STREAMS_FAILURE: 'SET_SLAVE_STREAMS_FAILURE',

  SET_SLAVE_SITES_SUCCESS: 'SET_SLAVE_SITES_SUCCESS',
  SET_SLAVE_SITES_FAILURE: 'SET_SLAVE_SITES_FAILURE',

  SET_SLAVE_SITE_SETTINGS_SUCCESS: 'SET_SLAVE_SITE_SETTINGS_SUCCESS',
  SET_SLAVE_SITE_SETTINGS_FAILURE: 'SET_SLAVE_SITE_SETTINGS_FAILURE',

  SET_SLAVE_STATS_DICTIONARY_SUCCESS: 'SET_SLAVE_STATS_DICTIONARY_SUCCESS',
  SET_SLAVE_STATS_DICTIONARY_FAILURE: 'SET_SLAVE_STATS_DICTIONARY_FAILURE',

  SET_SLAVE_HOLD_DETAILS_SUCCESS: 'SET_SLAVE_HOLD_DETAILS_SUCCESS',
  SET_SLAVE_HOLD_DETAILS_FAILURE: 'SET_SLAVE_HOLD_DETAILS_FAILURE',
  SET_SLAVE_HOLD_DETAILS_SETTINGS_SUCCESS: 'SET_SLAVE_HOLD_DETAILS_SETTINGS_SUCCESS',
  SET_SLAVE_HOLD_DETAILS_SETTINGS_FAILURE: 'SET_SLAVE_HOLD_DETAILS_SETTINGS_FAILURE',

  DELETE_SLAVE_WALLETS_SUCCESS: 'DELETE_SLAVE_WALLETS_SUCCESS',
  DELETE_SLAVE_WALLETS_FAILURE: 'DELETE_SLAVE_WALLETS_FAILURE',
};